export const RECEIVED_HRES31X_COLUMNS_LABELS = 'RECEIVED_HRES31X_COLUMNS_LABELS'
export const RECEIVED_HRES31X_DETAIL_INDEX = 'RECEIVED_HRES31X_DETAIL_INDEX'
export const RECEIVED_HRES31X_DETAIL_TOPIC = 'RECEIVED_HRES31X_DETAIL_TOPIC'
export const RECEIVED_HRES31X_DETAIL_TAB1 = 'RECEIVED_HRES31X_DETAIL_TAB1'
export const RECEIVED_HRES31X_DETAIL_TAB2_19 = 'RECEIVED_HRES31X_DETAIL_TAB2_19'
export const RECEIVED_HRES31X_DETAIL_TAB13_POPUP = 'RECEIVED_HRES31X_DETAIL_TAB13_POPUP'

export const SET_HRES31X_COLUMNS = 'SET_HRES31X_COLUMNS'
export const GET_HRES31X_COLUMNS = 'GET_HRES31X_COLUMNS'
export const SET_HRES31X_LABELS = 'SET_HRES31X_LABELS'
export const GET_HRES31X_LABELS = 'GET_HRES31X_LABELS'

export const SET_HRES31X_DETAIL_INDEX = 'SET_HRES31X_DETAIL_INDEX'
export const GET_HRES31X_DETAIL_INDEX = 'GET_HRES31X_DETAIL_INDEX'
export const SET_HRES31X_DETAIL_TOPIC = 'SET_HRES31X_DETAIL_TOPIC'
export const GET_HRES31X_DETAIL_TOPIC = 'GET_HRES31X_DETAIL_TOPIC'
export const SET_HRES31X_DETAIL_TAB1 = 'SET_HRES31X_DETAIL_TAB1'
export const GET_HRES31X_DETAIL_TAB1 = 'GET_HRES31X_DETAIL_TAB1'
export const SET_HRES31X_DETAIL_TAB2 = 'SET_HRES31X_DETAIL_TAB2'
export const GET_HRES31X_DETAIL_TAB2 = 'GET_HRES31X_DETAIL_TAB2'
export const SET_HRES31X_DETAIL_TAB3 = 'SET_HRES31X_DETAIL_TAB3'
export const GET_HRES31X_DETAIL_TAB3 = 'GET_HRES31X_DETAIL_TAB3'
export const SET_HRES31X_DETAIL_TAB4 = 'SET_HRES31X_DETAIL_TAB4'
export const GET_HRES31X_DETAIL_TAB4 = 'GET_HRES31X_DETAIL_TAB4'
export const SET_HRES31X_DETAIL_TAB5 = 'SET_HRES31X_DETAIL_TAB5'
export const GET_HRES31X_DETAIL_TAB5 = 'GET_HRES31X_DETAIL_TAB5'
export const SET_HRES31X_DETAIL_TAB6 = 'SET_HRES31X_DETAIL_TAB6'
export const GET_HRES31X_DETAIL_TAB6 = 'GET_HRES31X_DETAIL_TAB6'
export const SET_HRES31X_DETAIL_TAB7 = 'SET_HRES31X_DETAIL_TAB7'
export const GET_HRES31X_DETAIL_TAB7 = 'GET_HRES31X_DETAIL_TAB7'
export const SET_HRES31X_DETAIL_TAB8 = 'SET_HRES31X_DETAIL_TAB8'
export const GET_HRES31X_DETAIL_TAB8 = 'GET_HRES31X_DETAIL_TAB8'
export const SET_HRES31X_DETAIL_TAB9 = 'SET_HRES31X_DETAIL_TAB9'
export const GET_HRES31X_DETAIL_TAB9 = 'GET_HRES31X_DETAIL_TAB9'
export const SET_HRES31X_DETAIL_TAB10 = 'SET_HRES31X_DETAIL_TAB10'
export const GET_HRES31X_DETAIL_TAB10 = 'GET_HRES31X_DETAIL_TAB10'
export const SET_HRES31X_DETAIL_TAB11 = 'SET_HRES31X_DETAIL_TAB11'
export const GET_HRES31X_DETAIL_TAB11 = 'GET_HRES31X_DETAIL_TAB11'
export const SET_HRES31X_DETAIL_TAB12 = 'SET_HRES31X_DETAIL_TAB12'
export const GET_HRES31X_DETAIL_TAB12 = 'GET_HRES31X_DETAIL_TAB12'
export const SET_HRES31X_DETAIL_TAB13 = 'SET_HRES31X_DETAIL_TAB13'
export const GET_HRES31X_DETAIL_TAB13 = 'GET_HRES31X_DETAIL_TAB13'
export const SET_HRES31X_DETAIL_TAB14 = 'SET_HRES31X_DETAIL_TAB14'
export const GET_HRES31X_DETAIL_TAB14 = 'GET_HRES31X_DETAIL_TAB14'
export const SET_HRES31X_DETAIL_TAB15 = 'SET_HRES31X_DETAIL_TAB15'
export const GET_HRES31X_DETAIL_TAB15 = 'GET_HRES31X_DETAIL_TAB15'
export const SET_HRES31X_DETAIL_TAB16 = 'SET_HRES31X_DETAIL_TAB16'
export const GET_HRES31X_DETAIL_TAB16 = 'GET_HRES31X_DETAIL_TAB16'
export const SET_HRES31X_DETAIL_TAB17 = 'SET_HRES31X_DETAIL_TAB17'
export const GET_HRES31X_DETAIL_TAB17 = 'GET_HRES31X_DETAIL_TAB17'
export const SET_HRES31X_DETAIL_TAB18 = 'SET_HRES31X_DETAIL_TAB18'
export const GET_HRES31X_DETAIL_TAB18 = 'GET_HRES31X_DETAIL_TAB18'
export const SET_HRES31X_DETAIL_TAB19 = 'SET_HRES31X_DETAIL_TAB19'
export const GET_HRES31X_DETAIL_TAB19 = 'GET_HRES31X_DETAIL_TAB19'
export const SET_HRES31X_DETAIL_TAB13_POPUP = 'SET_HRES31X_DETAIL_TAB13_POPUP'
export const GET_HRES31X_DETAIL_TAB13_POPUP = 'GET_HRES31X_DETAIL_TAB13_POPUP'



// WEBPACK FOOTER //
// ./src/store/modules/hres31x/mutation-types.js